import { render, staticRenderFns } from "./addManagemen.vue?vue&type=template&id=87a8fde2&scoped=true&"
import script from "./addManagemen.vue?vue&type=script&lang=js&"
export * from "./addManagemen.vue?vue&type=script&lang=js&"
import style0 from "./addManagemen.vue?vue&type=style&index=0&id=87a8fde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a8fde2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87a8fde2')) {
      api.createRecord('87a8fde2', component.options)
    } else {
      api.reload('87a8fde2', component.options)
    }
    module.hot.accept("./addManagemen.vue?vue&type=template&id=87a8fde2&scoped=true&", function () {
      api.rerender('87a8fde2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/communityDynamic/communityComment/components/addManagemen.vue"
export default component.exports